<template>
  <div class="px-5">
    <b-alert variant="danger" show
    >{{ message }}</b-alert>
    <br>
  </div>
</template>

<script>
export default {
  props: ['message'],
  data() {
    return {
      dismissCountDown: 3,
    };
  },
  // methods: {
  //   countDownChanged(dismissCountDown) {
  //     this.dismissCountDown = dismissCountDown;
  //   },
  // },
};
</script>
